import { render, staticRenderFns } from "./ScheduleEthicalAdvicesButton.vue?vue&type=template&id=4cb64678&"
import script from "./ScheduleEthicalAdvicesButton.vue?vue&type=script&lang=js&"
export * from "./ScheduleEthicalAdvicesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
